export default __webpack_public_path__ + "static/roof_b.954c34004de16646753ca878ede8aa2b.svg";